import React, { Fragment } from "react";

import {
  AppBar,
  Grid,
  IconButton,
  Toolbar,
  Tooltip,
  Typography,
  fade,
  makeStyles,
} from "@material-ui/core";
import { ChevronRight as GoIcon } from "react-feather";

import { CalendarFooterProps } from "./types";

const useStyles = makeStyles(theme => ({
  appBar: {
    backgroundColor: fade(theme.palette.primary.main, 0.7),
    overflow: "hidden",
  },
  gutters: {
    padding: theme.spacing(0, 4),
  },
  title: {
    opacity: "0.7",
  },
  subtitle: {
    lineHeight: "24px",
    fontWeight: "bold",
  },
}));

const CalendarFooter: React.FC<CalendarFooterProps> = ({
  nextLessonTime,
  numberOfLessons,
  onViewLessonClicked = () => {},
  loading,
}) => {
  const classes = useStyles();

  return (
    <AppBar
      position="relative"
      component="footer"
      className={classes.appBar}
      data-test="calendar-footer"
    >
      <Toolbar classes={{ gutters: classes.gutters }}>
        <Grid container justify="center" spacing={4}>
          <Grid item>
            <Typography variant="overline" className={classes.title}>
              Lessons today
            </Typography>
            <Typography variant="h5" className={classes.subtitle}>
              {loading ? "-" : numberOfLessons}
            </Typography>
          </Grid>
          {numberOfLessons !== 0 && (
            <Fragment>
              <Grid item>
                <Typography variant="overline" className={classes.title}>
                  Next Lesson
                </Typography>
                <Typography variant="h5" className={classes.subtitle}>
                  {loading ? "-" : nextLessonTime}
                </Typography>
              </Grid>
              <Grid item>
                {/* This needs a span as Tooltip cthrows a console.error if the button is disabled and no span is here */}
                <Tooltip title="View lesson" placement="right">
                  <span>
                    <IconButton
                      onClick={onViewLessonClicked}
                      disabled={loading}
                    >
                      <GoIcon color="white" size={20} />
                    </IconButton>
                  </span>
                </Tooltip>
              </Grid>
            </Fragment>
          )}
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default CalendarFooter;
